module.exports = "<div class=\"container\">\n    <router-outlet></router-outlet>\n</div>\n<ng-http-loader spinner=\"sk-chasing-dots\"></ng-http-loader>"